import { Container } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Apps, SocialApp } from "../../Constant";
import UserProfile from "./UserProfile/UserProfile";
import { useCallback, useState } from "react";
import SocialAppTabContent from "./UserContext";

const SocialAppContainer = () => {
    const [activeTab, setActiveTab] = useState(1);
    const callback = useCallback((tab: number) => {
      setActiveTab(tab);
    }, []);
    
  return (
    <>
      <Breadcrumbs pageTitle={SocialApp} parent={Apps} title={SocialApp} />
      <Container fluid>
        <div className="user-profile social-app-profile">
          <UserProfile callback={callback} />
          <SocialAppTabContent activeTab={activeTab}/>
        </div>
      </Container>
    </>
  );
};

export default SocialAppContainer;
